import { EventSourcePolyfill } from 'event-source-polyfill';
import Cookies from 'js-cookie';

export function createListener(id: any, customFunction: Function, login?: any) {
    const mercureToken = Cookies.get('mercureAuthorization') || localStorage.getItem('token_mercure');
    const url = new URL(process.env.REACT_APP_MERCURE_URL);
    const prefix = login ? `login/${login}` : 'command';
    url.searchParams.append('topic', `${process.env.REACT_APP_MERCURE_TOPIC_URL}/${prefix}/${id}`);
    const eventSource = new EventSourcePolyfill(url, {
        headers: { Authorization: `Bearer ${mercureToken}` },
    });
    eventSource.onmessage = (event) => {
        customFunction(JSON.parse(event.data), id);
        if (id !== 'alert') {
            eventSource.close();
        }
    };
    return eventSource;
}
